import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { LanguageResource } from "@exonn/js-sdk";

export const module: ModuleOptions<LanguageResource> = {
  resource: ResourceEnum.Language,
  bigIcon: <i className="icon-20-lang" />,
  smallIcon: <i className="icon-15-lang" />,

  list: {
    hideDeleteAction: (row) => row.is_default,
  },
};
